import Client from "./clients/rest";
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

export default {
    get() {
        return Client.get("/meta/s");
    },

    getSettings(businessId) {
        return Client.get(`business/${businessId}/get_settings`);
    },

    updateSettings(businessId, body) {
        return Client.post(`business/${businessId}/update_settings`, body);
    },

    OnlineManagmentInsertOrUpdate(businessId, body) {
        return Client.post(`business/${businessId}/OnlineManagmentInsertOrUpdate`, body);
    },
};